export function getFieldName(key: string): string {
    if (key.split('-')?.length > 1) key = key.split('-')[0];
    switch (key) {
      case 'displayName':
        return 'Display Name';
      case 'fullName':
        return 'Full Name';
      case 'shortName':
        return 'Short Name'
      case 'variations':
        return 'Variations';
      default:
        return key;
    }
  };

export const DISALLOWED_CHARACTERS = /[<>'"&%*@#!?;=]/g;
export const DISPLAY_NAME_MAX_LENGTH = 5;
export const OTHER_FIELDS_MAX_LENGTH = 30;
export const VARIATIONS_MAX_LENGTH = 500;

export const VARIATIONS_FIELD = 'variations';
export const DISPLAY_NAME_FIELD = 'displayName';
export const MESAUREMENTS_UNSAVED_CHANGES = 'You have unsaved changes. Please save before leaving.';
export const MEASUREMENTS_CHANGES_SAVED = 'Measurement unit configuration saved successfully.';

export const MEASUREMENTS_HEADERS = [
  { category: '', columns: ['displayName', 'shortName', 'fullName', 'variations'] },
];

export const FIELDS_TO_IGNORE_VALIDATIONS = ['id', 'errors', 'isNew', 'isMappedToProduct', 'disableDelete']

export const CANNOT_SELECT_MEASUREMENT_UNIT = 'Cannot select unit of measurement as it is linked to a product or add-on.'

export const SPECIAL_CHARACTERS_MEASUREMENTS = "< > ' \" & % * @ # ^ ! ? ; = ";